import { type FC, useRef, useState } from 'react'
import styled from '@emotion/styled'

import Image from '@segment/matcha/components/Image'
import ColumnTrack from '@segment/matcha/components/ColumnTrack'
import { BoxLogo, SanofiLogo } from '@segment/matcha/components/CompanyLogos/Company'
import useModal from '@segment/matcha/components/Modal/useModal'

import * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import VideoCard from './VideoCard'
import VideoModal from './../VideoModal'

import BoxImage from './assets/BoxImage.jpg'
import SanofiImage from './assets/SanofiImage.jpg'
import RoostifyImage from './assets/RoostifyImage.jpg'
import RoostifyLogo from './assets/RoostifyLogo.png'
import BoxVideoCoverImage from './assets/BoxVideoCoverImage.png'
import SanofiVideoCoverImage from './assets/SanofiVideoCoverImage.png'
import RoostifyVideoCoverImage from './assets/RoostifyVideoCoverImage.png'

const copy = {
  heading: `More than 25,000 companies are powered by good data with Segment `,
  description: `Empower your teams to make real-time decisions, accelerate growth, and deliver world-class customer experiences.`,
}

const cards = [
  {
    id: `box`,
    href: `#box`,
    logo: <BoxLogo />,
    image: BoxImage,
    videoUrl: `https://youtu.be/t8BFUnn66Wo`,
    videoCover: BoxVideoCoverImage,
  },
  {
    id: `sanofi`,
    href: `#sanofi`,
    logo: <SanofiLogo />,
    image: SanofiImage,
    videoUrl: `https://youtu.be/tRlWAMX_2Pc`,
    videoCover: SanofiVideoCoverImage,
  },
  {
    id: `roostify`,
    href: `#roostify`,
    logo: <Image src={RoostifyLogo} width={876} height={125} alt="" />,
    image: RoostifyImage,
    videoUrl: `https://youtu.be/Cb6AgkFn0dU`,
    videoCover: RoostifyVideoCoverImage,
  },
]

const Companies: FC = () => {
  const modalRef = useRef(null)
  const [activeVideo, setActiveVideo] = useState<number | null>(null)
  const modalOpenState = useState(false)
  const [opened] = modalOpenState
  const { getControlOpenProps } = useModal(modalRef, modalOpenState)

  return (
    <Wrapper>
      <StyledSection variant="centered">
        <StyledCopy>
          <CopyText.Heading variant="h2" tag="h2">
            {copy.heading}
          </CopyText.Heading>
          <CopyText.Description variant="pExtraLarge" tag="p">
            {copy.description}
          </CopyText.Description>
        </StyledCopy>

        <StyledContent>
          <ColumnTrack overrides={{ md: 3 }} columns={1}>
            {cards.map((card, index) => (
              <VideoCard
                {...getControlOpenProps({
                  onClick() {
                    setActiveVideo(index)
                  },
                })}
                key={card.id}
                logo={card.logo}
                image={card.image}
              />
            ))}
          </ColumnTrack>
        </StyledContent>
      </StyledSection>

      {opened && activeVideo !== null ? (
        <VideoModal ref={modalRef} url={cards[activeVideo].videoUrl} cover={cards[activeVideo].videoCover}></VideoModal>
      ) : null}
    </Wrapper>
  )
}

const Wrapper = styled.div``

const StyledSection = styled(SectionBase)`
  ${Section.Wrapper} {
    gap: 40px;

    ${({ theme }) => theme.breakpoints.up(`lg`)} {
      gap: 80px;
    }
  }
`

const StyledCopy = styled(Section.Copy)`
  max-width: 612px;
  text-align: center;
`

const StyledContent = styled(Section.Contents)`
  max-width: 1120px;
`

export default Companies
